export default class CreateOverviewModalController {

    constructor($scope, $uibModalInstance, relationType, $injector, selectedTemplate, store) {
        this.store = store;
        this.scope = $scope;
        this.modalInstance = $uibModalInstance;
        this.relationType = relationType;
        this.injector = $injector;
        this.api = $injector.get('$http');
        this.translate = $injector.get('$translate');
        this.model = {};

        this.customs = _.range(1, 20);

        this.selectedTemplate = selectedTemplate;

        this._loadDeposits();
    }

    createDocument() {
        this.modalInstance.close(this.model);
    }

    dismiss() {
        this.modalInstance.dismiss();
    }

    _refreshScope() {
        this.scope.$applyAsync();
    }

    _loadDeposits() {
        this.deposits = {
            relationTypes: {}
        };

        this.injector.get('Deposit').getRemoteDeposit('documents', 'template_relation_types').then((relationTypes) => {
            this.deposits.relationTypes = _.cloneDeep(relationTypes);
        })
    }
}

CreateOverviewModalController.$inject = [
    '$scope',
    '$uibModalInstance',
    'relationType',
    '$injector',
    'selectedTemplate',
    'store'
];



// WEBPACK FOOTER //
// ./src/app/modules/documents/controllers/modals/create-overview-modal-controller.js